import Mention from '@tiptap/extension-mention';

// ('<p data-type="block" data-alignment="align-left" data-font-size="normal"><span class="px-mention" data-user-id="1729382256911306768" data-username="@">Vojtech Jungmann</span> </p>');

const HubsMention = Mention.extend({
	addAttributes() {
		return {
			id: {
				default: null,
			},
			label: {
				default: null,
			},
		};
	},
	parseHTML() {
		return [
			{
				tag: 'span[data-user-id]',
				getAttrs: (dom) => {
					const id = (dom as HTMLElement).getAttribute('data-user-id');
					const label = (dom as HTMLElement).textContent;
					return {
						id,
						label,
					};
				},
			},
		];
	},
	renderHTML(props) {
		const { node } = props;
		return [
			'span',
			{
				class: 'px-mention mention',
				'data-user-id': node.attrs.id as string,
				//'data-username': `@${node.attrs.label}`,
				'data-username': `@`,
			},
			`${node.attrs.label}`,
		];
	},
});
export default HubsMention;
